<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="tags">
            <template v-slot:options>
                <b-button
                    class="btn-admin-users"
                    v-b-modal="'add-tag-modal'"
                    variant="primary">
                    <i class="fas fa-plus fa-fw"></i> {{ $t('modules.add_tags') }}
                </b-button>

                <design-2021-modules-add-tag-modal></design-2021-modules-add-tag-modal>
            </template>

            <template v-slot:cell(color)="data">
                <div
                    class="color-icon"
                    :style="cssVars(data.item.color)">
                    <i
                        class="fas fa-circle"
                        v-b-tooltip.hover
                        :title="`Tag kleur: ${data.item.color}`">
                    </i>
                </div>
            </template>
            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-edit btn-edit-tag"
                        v-b-modal="'update-tag-modal' + data.item.id"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('modules.edit_tag')">
                    </b-button>

                    <design-2021-modules-update-tag-modal :tag-in="data.item"></design-2021-modules-update-tag-modal>

                    <b-button
                        class="btn-delete-admin-user btn-remove"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('modules.delete_tag')"
                        @click="removeTag(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../app';

const moduleTagsOrds = ords.use('module_tags');

export default {
    name: 'design-2021-module-tag-index-component',
    props: ['tagsIn'],
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'color',
                    label: this.$t('common.colour'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            tags: [],
        };
    },

    methods: {
        removeTag(tag) {
            this.alert
                .confirm(this.$t('modules.delete_tag'), this.$t('modules.are_you_sure_you_want_to_delete_this_tag'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.deleteModuleTag(tag.id)).then(
                            (response) => {
                                tag.remove(tag.id);

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        cssVars(color) {
            return {
                '--category-color': color,
            };
        },
    },

    mounted() {
        moduleTagsOrds.add(this.tagsIn);

        moduleTagsOrds.get().subscribe((tags) => {
            this.tags = tags;
        });
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    align-items: center;

    .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.color-icon {
    color: var(--category-color);
}
</style>
